import React, { useEffect } from "react";
import {
  XMarkIcon,
  ChevronRightIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import logo from "../assets/logo.png";
import AOS from "aos";
import "aos/dist/aos.css";
import wavinghand from "../assets/waving hand.png";
import cardimg from "../assets/cardimg.jpg";

function LandingWindow({ setView, setupDetails, setIsOpen, setActiveIcon }) {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true, // Whether the animation should happen only once
    });
  }, []);

  return (
    <div
      className="-m-2.5 overflow-auto scrollbar-thin"
      style={{
        background: `linear-gradient(to bottom, ${
          setupDetails?.widgetCustomizations?.primaryColor || "#0a2f96"
        }, #f7f7f7 40%)`,
      }}
    >
      <div>
        <div className=" w-full pt-2 flex">
          <img className="h-20 w-20 p-2" alt="brand-icon" src={logo} />
          <div className="flex items-center gap-3 ml-auto p-3">
            <div className="flex justify-end">
              <XMarkIcon
                className="h-5 w-5 text-slate-100 cursor-pointer"
                onClick={() => setIsOpen(false)}
              />
            </div>
          </div>
        </div>
        <div className="text-blue-900 font-bold text-2xl p-4 text-left mt-16">
          <div className="flex items-center text-left gap-2">
            <div
              className="text-3xl"
              style={{
                color: setupDetails?.widgetCustomizations?.primaryColor,
              }}
            >
              Hi there,
            </div>
            <div>
              <img src={wavinghand} alt="" className="w-11 h-11" />
            </div>
          </div>
          <div
            className="text-3xl"
            style={{
              color: setupDetails?.widgetCustomizations?.secondaryColor,
            }}
          >
            How Can We Help?
          </div>
        </div>
      </div>

      {setupDetails?.widgetCustomizations?.aiBot && (
        <div
          onClick={() => setView("Bot")}
          className="flex bg-white justify-between border border-gray-200 rounded-md shadow p-2 m-4 cursor-pointer"
        >
          <div className="pl-2">
            <div className="text-sm font-bold text-left">Ask a Question</div>
            <div className="text-xs">AI Agent & Team can help</div>
          </div>
          <div className="flex items-center gap-x-7">
            <div>
              <img
                src={setupDetails?.widgetCustomizations?.logoUrl}
                alt="Logo"
                style={{
                  background: `linear-gradient(90deg, ${
                    setupDetails?.widgetCustomizations?.primaryColor ||
                    "#4c73de"
                  } 0%,  ${
                    setupDetails?.widgetCustomizations?.secondaryColor ||
                    "#2a4dad"
                  } 100%)`,
                }}
                className="bg-blue-700 w-8 rounded-lg"
              />
            </div>
            <ChevronRightIcon className="w-5 h-5" />
          </div>
        </div>
      )}

      {/* CardsSection */}
      <a
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        className="block m-4 rounded-lg shadow bg-white"
      >
        <img className="rounded-t-lg" src={cardimg} alt="" />
        <div className="p-5">
          <h5 className="mb-2 font-bold">
            Noteworthy technology acquisitions 2024
          </h5>
          <p className="text-sm">
            Here are the biggest enterprise technology acquisitions of 2024 so
            far, in reverse chronological order.
          </p>
        </div>
      </a>

      <a
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        className="block m-4 rounded-lg shadow bg-white"
      >
        <img className="rounded-t-lg" src={cardimg} alt="" />
        <div className="p-5">
          <h5 className="mb-2 font-bold">
            Noteworthy technology acquisitions 2024
          </h5>
          <p className="text-sm">
            Here are the biggest enterprise technology acquisitions of 2024 so
            far, in reverse chronological order.
          </p>
        </div>
      </a>

      {/* SearchSection  */}
      <div className="p-2 m-4 rounded-lg shadow flex flex-col gap-y-2 bg-white">
        <div className="font-semibold text-base">
          <button
            className="flex justify-between items-center w-full bg-gray-200 px-4 py-3 rounded-lg"
            onClick={() => {
              setActiveIcon("help");
              setView("Help");
            }}
          >
            <span>Search for help</span>
            <MagnifyingGlassIcon className="h-5 w-5" strokeWidth={2} />
          </button>
        </div>
        <div
          className="flex justify-between items-center px-4 py-3 hover:bg-gray-300 hover:rounded-lg cursor-pointer"
          onClick={() => setView("AIAgentInfo")}
        >
          <span>Fin 2 — DexKor's latest generation of AI agent</span>
          <ChevronRightIcon className="h-4 w-4" strokeWidth={3} />
        </div>
        <div
          className="flex justify-between items-center px-4 py-3 hover:bg-gray-300 hover:rounded-lg  cursor-pointer"
          onClick={() => setView("MetricsAndAttributes")}
        >
          <span>Reporting metrics & attributes</span>
          <ChevronRightIcon className="h-4 w-4" strokeWidth={3} />
        </div>
        <div
          className="flex justify-between items-center px-4 py-3 hover:bg-gray-300 hover:rounded-lg  cursor-pointer"
          onClick={() => setView("CDAInfo")}
        >
          <span>Create and track custom data attributes (CDAs)</span>
          <ChevronRightIcon className="h-4 w-4" strokeWidth={3} />
        </div>
        <div
          className="flex justify-between items-center px-4 py-3 hover:bg-gray-300 hover:rounded-lg  cursor-pointer"
          onClick={() => setView("SupportContent")}
        >
          <span>Add your support content for Fin AI Agent</span>
          <ChevronRightIcon className="h-4 w-4" strokeWidth={3} />
        </div>
      </div>

      {/* CardSection  */}
      <a
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        className="block m-4 bg-white rounded-lg shadow"
      >
        <img className="rounded-t-lg" src={cardimg} alt="" />
        <div className="p-5">
          <h5 className="mb-2 font-bold">
            Noteworthy technology acquisitions 2024
          </h5>
          <p className="text-sm">
            Here are the biggest enterprise technology acquisitions of 2024 so
            far, in reverse chronological order.
          </p>
        </div>
      </a>
    </div>
  );
}

export default LandingWindow;
